import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fill="var(--color-difficulty-hard)"
      d="M9.402 6c1.155-2 4.041-2 5.196 0l5.196 9c1.155 2-.288 4.5-2.598 4.5H6.804c-2.31 0-3.753-2.5-2.598-4.5z"
    />
  </>
);

const DifficultyHard = Icon('difficulty-hard', svgContents);

export default DifficultyHard;
